import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { rgba } from '@shared/utils/style/rgba';

type FilterButtonProps = Readonly<{
  text: string;
  isDisabled?: boolean;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  /** Accent color for the hover state. Defaults to the brand blurple. */
  accentColor?: string;
}>;

// Default blurple hover styling (matches the brand `newUITest1` token).
const DEFAULT_HOVER = {
  color: 'newUITest1',
  borderColor: 'newUITest1',
  backgroundColor: 'rgba(73, 81, 239, 0.10)',
} as const;

export const DropdownButton: React.FC<FilterButtonProps> = ({ text, startIcon, endIcon, isDisabled, accentColor }) => {
  // Hover tint derives from the accent at the same 0.10 alpha the blurple default uses.
  const hoverStyles = accentColor ? { color: accentColor, borderColor: accentColor, backgroundColor: rgba(accentColor, 0.1) } : DEFAULT_HOVER;

  return (
    <ButtonV2
      paddingX={4}
      paddingY={3}
      borderRadius={3}
      variant="outline"
      endIcon={endIcon}
      intent="neutral"
      border="1px solid"
      borderColor="mono3"
      startIcon={startIcon}
      disabled={isDisabled}
      height="fit-content"
      typographyVariant="label2"
      fontSize={{ _: pxToRem(11), md: pxToRem(13) }}
      _hover={hoverStyles}
    >
      {text}
    </ButtonV2>
  );
};
